import React from 'react'

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props)
    this.state = { hasError: false, error: null }
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error }
  }

  componentDidCatch(error, errorInfo) {
    console.error(`[ERROR_BOUNDARY][${this.props.name || 'unknown'}] Component crashed:`, error.message)
    console.error(`[ERROR_BOUNDARY][${this.props.name || 'unknown'}] Stack:`, errorInfo.componentStack)
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          padding: '1rem',
          background: '#fee',
          border: '2px solid #c00',
          borderRadius: '8px',
          margin: '0.5rem',
          fontFamily: 'monospace',
          fontSize: '0.85rem',
          overflow: 'auto',
        }}>
          <strong>[{this.props.name || 'Component'}] CRASHED</strong>
          <pre style={{ whiteSpace: 'pre-wrap', marginTop: '0.5rem' }}>
            {this.state.error?.message}
          </pre>
        </div>
      )
    }
    return this.props.children
  }
}

export default ErrorBoundary
